import { Application } from '@src/hooks/useApplications';

export const getAcademicPartnerName: (application: Application) => string = (application) => {
  return (
    application.program.studentFacingAcademicPartner?.name ??
    application.program.studentFacingAcademicPartner?.informalName ??
    ''
  );
};

export const getAcademicPartnerUuid: (application: Application) => string = (application) => {
  return application.academicPartnerUuid || '';
};

/**
 * If an enrollment intention is null and the enrollment period is not expired
 * then this application requires a user to confirm their intent. This is strictly
 * for art approved applications at MODEL_L programs
 *
 * @param application
 * @returns interface Application[]
 */

export const getApplicationsOpenForEnrollment = (application: Application[] = []) => {
  return application.filter((application) => {
    const modelLSchool = application.program.academicPartner?.academicModel === 'MODEL_L';
    const applicationRequiresAction = application.enrollmentIntentions?.find(
      (enrollmentIntention) => {
        return (
          enrollmentIntention.intendsToEnroll === null &&
          (!enrollmentIntention.isExpired ||
            (enrollmentIntention.isExpired && enrollmentIntention.newTerm !== null))
        );
      }
    );

    return modelLSchool && applicationRequiresAction;
  });
};
